
export class WorkOrderDocumentsConfiguration {

  WorkOrder: { Oid: number } | any | null = null;
  Document : any | null = null

  private constructor() {
  }

  public static create = () => new WorkOrderDocumentsConfiguration();

  setWorkOrderOid(value: number | null) {

    this.WorkOrder = value ? {Oid: value} : null;
    return this;

  }

  setDocument(value: any | null) {

    this.Document = value;
    return this;

  }

}
